import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BroadCastMessage } from '../iframe/iframe.service';

//This handle all the messages coming in from the tab and send it up to main
// through the iframe. We only use window.parent here to send up to main.

@Injectable()
export class LoaderMessagingService {
  prefix = '[ZaverCheckout]';

  constructor() {}

  private eventSubject = new Subject<string>();
  event$ = this.eventSubject.asObservable();

  sendAppEvent(message: string) {
    this.eventSubject.next(message);
  }

  closeChildWindow(childWindow: Window) {
    if (childWindow != null && !childWindow.closed) {
      childWindow.close();
      this.closeTab();
    }
  }

  handleMessage(message) {
    if (!this.forUs(message.data)) {
      return;
    }

    let parsedMessage = null;
    try {
      parsedMessage = JSON.parse(
        message.data.substring('[ZaverCheckout]'.length)
      );
    } catch (error) {
      this.zlog(error);
      return;
    }

    if (!parsedMessage.zcoType) {
      return;
    }
    this.zlog(
      'type: ' +
        parsedMessage.zcoType +
        ',value: ' +
        parsedMessage.value +
        ' innerURL: ' +
        parsedMessage.innerURL
    );
    switch (parsedMessage.zcoType as MessageType) {
      case MessageType.SUCCESS_REDIRECT:
        if (parsedMessage.value === null) {
          window.location.reload();
        } else {
          this.successRedirect(parsedMessage.value);
          this.zlog(
            'got success redirect, navigating to: ' +
              parsedMessage.value +
              'innerUrl: ' +
              parsedMessage.innerURL
          );
        }
        break;
      case MessageType.URL_UPDATE:
        this.urlUpdate(parsedMessage.value);
        this.zlog('url was updatet to: ' + parsedMessage.value);
        break;
      case MessageType.CLOSE_TAB:
        this.sendAppEvent('closed');
        this.closeTab();
        this.zlog('tab was closed: ' + parsedMessage.value);
        break;
      case MessageType.OPEN_TAB:
        this.openParentTab(parsedMessage.value);
        break;
      case MessageType.OPEN_POPUP:
        this.openParentPopup(parsedMessage.value);
    }
  }

  forUs(message: string): boolean {
    return (
      ('' + message).substr(0, '[ZaverCheckout]'.length) === '[ZaverCheckout]'
    );
  }

  private zlog(message: string) {
    // Always postMessage to iframe.
    window.parent.postMessage('[ZaverLoader] @' + message, '*');
    console.log(message);
  }

  successRedirect(successUrl: string) {
    this.post({
      zcoType: MessageType.SUCCESS_REDIRECT,
      value: successUrl,
      innerURL:
        window.location.href.search('&redirectOrdered=true') > -1
          ? window.location.href
          : window.location.href + '&redirectOrdered=true',
    });
  }

  openParentTab(url) {
    this.post({
      zcoType: MessageType.OPEN_TAB,
      value: url,
    });
  }

  openParentPopup(url) {
    this.post({
      zcoType: MessageType.OPEN_TAB,
      value: url,
    });
  }

  urlUpdate(url: string) {
    this.post({
      zcoType: MessageType.URL_UPDATE,
      value: url,
    });
  }

  closeTab() {
    this.post({
      zcoType: MessageType.CLOSE_TAB,
      value: 'tab was closed',
    });
  }

  // Message is consumed by 'tools/loader' in this repo.
  private post(message: Message) {
    window.parent.postMessage(this.prefix + JSON.stringify(message), '*');
  }
}

export enum MessageType {
  URL_UPDATE = 'zaver-url-update',
  SUCCESS_REDIRECT = 'zaver-redirect-success',
  OPEN_TAB = 'zaver-parent-tab',
  OPEN_POPUP = 'zaver-parent-popup',
  CLOSE_TAB = 'zaver-close-tab',
}

export interface Message {
  zcoType: MessageType | BroadCastMessage;
  value: string;
  innerURL?: string;
}
